enum FeatureFlagSettings {
    Megatron = "Megatron",//configuring featureflag in table user.feature_flag
     
  }
  
  export default FeatureFlagSettings;
  